

const LoadingScreen = props => {
  return (
    <div>Loading Screen</div>
  )
};

export default LoadingScreen;